import React from 'react';
import { connect, useSelector } from 'react-redux';

import { paginate } from 'bundles/connect/components/store/actions/results';
import { Pagination } from 'react-bootstrap-5';
import { selectLoading } from '../../../store/selectors/ui';
import { selectPage, selectTotalPages } from 'bundles/connect/components/store/selectors/results';

type PaginatorProps = {
  containerRef: React.RefObject<HTMLDivElement>;
  paginate: (page: number) => void;
}

export function Paginator({ containerRef, paginate }: PaginatorProps) {
  const loading = useSelector(selectLoading);
  const page = useSelector(selectPage);
  const totalPages = useSelector(selectTotalPages);

  const handlePageChange = (page: number) => {
    if (containerRef.current) containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });

    paginate(page);
  };

  if (!totalPages || totalPages <= 1) return null;

  return (
    <Pagination>
      {page > 2 && (<Pagination.First disabled={loading} onClick={() => handlePageChange(1)} />)}
      {page > 1 && (<Pagination.Prev disabled={loading} onClick={() => handlePageChange(page - 1)} />)}
      <Pagination.Item>{page}</Pagination.Item>
      {page < totalPages && (<Pagination.Next disabled={loading} onClick={() => handlePageChange(page + 1)} />)}
    </Pagination>
  );
}

export default connect(undefined, { paginate })(Paginator);
